import moment from 'moment'
import Head from 'next/head'
import { Event as EventJsonLdType } from 'schema-dts'
import { useEventContext } from 'context/EventContext'

function EventJsonLd() {
  const { event } = useEventContext()
  const url =
    event.publicUrl ||
    'https://apps.apple.com/us/app/upstream-give-get-help/id1464548496'
  const status = 'https://schema.org/EventScheduled'

  const json: EventJsonLdType = {
    '@type': 'Event',
    name: event.title,
    description: event.description,
    startDate: moment(event.startTime).format(),
    endDate: moment(event.startTime)
      .add(event.introductionTime, 'seconds')
      .format(),
    organizer: {
      '@type': 'Person',
      name: event.user.displayName!,
      image: event.user.thumb!
    },
    eventStatus: status,
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    location: {
      '@type': 'VirtualLocation',
      url: url
    },
    url: url,
    image: event.ogImageUrl || 'https://upstreamapp.com/static/robot.png'
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
        key="jsonld-event"
      />
    </Head>
  )
}

export default EventJsonLd
